import React from "react";
import { useFieldWrapper } from "../hooks";
import FormFieldString from "./FormFieldString";
import StringComponent, { StringComponentProps } from "./StringComponent";

export const StringComponentWrapper = (props: StringComponentProps) => {
	const WrappedComponent = useFieldWrapper(StringComponent, FormFieldString);
	return <WrappedComponent {...props} />;
};
